import { AppNavProvider } from "@vetty/internal-ui";
import Link from '@/components/AppLink';
import { usePathname } from '@/lib/router-navigation';
import { useContext, type ReactNode } from "react";
import { NavigationLoadingContext } from "@/contexts/NavigationLoadingContext";

export const AppNavBridge = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname();
  const navigationLoading = useContext(NavigationLoadingContext);

  return (
    <AppNavProvider
      pathname={pathname ?? "/"}
      onNavLinkClick={(href, event) => {
        navigationLoading?.onSidebarNavLinkClick(
          href,
          event as React.MouseEvent<HTMLAnchorElement>
        );
      }}
      renderLink={({ href, className, children: linkChildren, onClick }) => (
        <Link href={href} className={className} onClick={onClick}>
          {linkChildren}
        </Link>
      )}
    >
      {children}
    </AppNavProvider>
  );
};
